import React, { useEffect, useState } from 'react';
import homeIcon from '../../images/home.svg'
import shopIcon from '../../images/shop.svg'
import _ from 'lodash';
import DatePicker from "react-datepicker";
import useAuth from '../../hooks/useAuth';

const OutletSTO = () => {

    const { vehicleData, setVehicleData, outletCode, setOutletCode ,setDeliveryOutlets, startDate, setStartDate, endDate, setEndDate } = useAuth()
    const [outlets, setOutlets] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('http://localhost:5000/outlet-zones/0')
                const result = await response.json()
                result.status && setOutlets(result.outletZones.data)
            }
            catch (error) {
                fetchData()
            }
        }
        fetchData()
    }, [])

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(`http://localhost:5000/vehicleWiseData-email-date-range-code/0/${startDate.toISOString().split('T')[0]}/${endDate.toISOString().split('T')[0]}/${outletCode}`)
            const result = await response.json()
            if (result.status === true) {
                setVehicleData(result.vehicleWiseData)
            }
        }
        outletCode && fetchData()
    }, [setVehicleData, setDeliveryOutlets, startDate, endDate, outletCode])

    console.log(vehicleData)

    return (
        <div className='bg-brand'>
            <div className="container">
                <div className="d-flex justify-content-center align-items-center pt-3">
                    <img className='img-fluid me-2' src={homeIcon} alt="home icon" />
                    <h1 className='fw-bold mt-3'>STO Tracker</h1>
                </div>

                <div className="d-flex justify-content-center align-items-center">
                    <img className='img-fluid' src={shopIcon} alt="shop icon" />
                    {
                        outlets.length > 0 ?
                            <select
                                style={{
                                    // backgroundColor: '#FBF9F1',
                                    border: '1px solid #E8E4D0',
                                    fontSize: '12px',
                                    fontWeight: '500'
                                }}
                                onChange={(e) => setOutletCode(e.target.value)}
                                className='w-50 shadow py-2 rounded bg-white'>
                                {
                                    _.sortBy(outlets, 'code').map(item =>
                                        <option key={item.code} className='text-center py-1' value={item.code}>{item.code} {item.name}</option>
                                    )
                                }
                            </select>
                            :
                            <p style={{
                                fontSize: '12px',
                                fontWeight: '500'
                            }} className='ms-2 pt-3'>Loading the latest Outlets</p>
                    }
                </div>

                <div className="d-flex justify-content-between align-items-center mt-5">
                    <p className='mb-0 me-2'>From:</p>
                    <DatePicker
                        className='w-75 date-picker'
                        selected={startDate}
                        onChange={(date) => {
                            setStartDate(date)
                        }}
                    />

                    <p className='mb-0 me-2'>To:</p>
                    <DatePicker
                        className='w-75 date-picker'
                        selected={endDate}
                        onChange={(date) => {
                            setEndDate(date)
                        }}
                    />
                </div>

                <div style={{
                    // border:'1px solid #FFA538'
                    border: '1px solid #E8E4D0',
                }} className="mt-3 bg-white shadow-sm rounded p-4">
                    <h2 className='h6'>Select STO to start receiving products</h2>

                </div>
            </div>
        </div>
    );
};

export default OutletSTO;